export const imageUrls = {
    "false" : "https://credzyimages.s3.ap-south-1.amazonaws.com/icons/close-red-icon.svg",
    "true": "https://credzyimages.s3.ap-south-1.amazonaws.com/icons/success-green-check-mark-icon.svg"
}